module.exports = __webpack_public_path__ + "static/media/dai.15edf859.svg";